var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonSdk = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M39.994 44.21H8.006A4.006 4.006 0 014 40.204V28h40v12.204a4.006 4.006 0 01-4.006 4.006z", fill: fills.base }),
        React.createElement("path", { d: "M11.957 17.919v-7.83c0-3.358 2.786-6.089 6.21-6.089h11.61c3.424 0 6.21 2.731 6.21 6.09v7.829H31.98v-7.83c0-1.147-.99-2.083-2.204-2.083H18.167c-1.216 0-2.203.936-2.203 2.084v7.829h-4.007z", fill: fills.dark }),
        React.createElement("path", { d: "M8.006 13.976H40a4.006 4.006 0 014.006 4.006v9.969H4v-9.969a4.006 4.006 0 014.006-4.006z", fill: fills.light }),
        React.createElement("path", { d: "M23.941 34.05a2.033 2.033 0 01-2.034-2.035v-5.981a2.033 2.033 0 114.068 0v5.979c0 1.124-.91 2.036-2.034 2.036z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
